import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    resendEmail: () => void;
};

export const ForgotPasswordConfirm = ({ resendEmail }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className="flex flex-col text-center">
            <BodyPrimary className="mb-md">
                <BodyPrimary className="mb-md">{formatMessage(['forgotPasswordConfirmation', 'text'])}</BodyPrimary>
            </BodyPrimary>
            <BodyPrimary>
                {formatMessage(['forgotPasswordConfirmation', 'help'], {
                    values: {
                        link: (
                            <Link
                                key="forgot-password-confirm-link"
                                onClick={resendEmail}
                            >
                                {formatMessage(['forgotPasswordConfirmation', 'helpLink'])}
                            </Link>
                        ),
                    },
                })}
            </BodyPrimary>
        </div>
    );
};
